import * as AddFirmwareService from '../services/uploadFirmware'
import { type firmwareReq } from '../services/uploadFirmware'
import { addFirmwareInfoDataLoading, addFirmwareInfoDataError, addFirmwareInfoData, resetAddFirmware } from './addFirmwareInfoSlice'
import { FirmwareTypeDataLoadingAction, FirmwareTypeDataUpdateAction, FirmwareTypeDataErrorAction } from './getFirmwareTypeDataInfoSlice'
import * as FirmwareDetailsService from '../services/firmwareList'
import { firmwareListFilterFirmwareTypeLoadingAction, firmwareListFilterFirmwareTypeErrorAction, firmwareListFilterFirmwareTypeUpdateAction } from '../redux/getFirmwareFilterFirmwareTypeSlice'
import { firmwareListFilterAssetTypeLoadingAction, firmwareListFilterAssetTypeErrorAction, firmwareListFilterAssetTypeUpdateAction } from '../redux/getFirmwareFilterAssetTypeSlice'
import { firmwareListFilterVersionLoadingAction, firmwareListFilterVersionErrorAction, firmwareListFilterVersionUpdateAction } from '../redux/getFirmwareFilterVersionSlice'
import { FirmwareListLoadingAction, FirmwareListUpdateAction, FirmwareListErrorAction } from './firmwareListInfoSlice'
import { exportFirmwareListLoadingAction, exportFirmwareListUpdateAction, exportFirmwareListErrorAction } from './exportFirmwareListSlice'
import { deleteFirmwareLoadingAction, deleteFirmwareUpdateAction, deleteFirmwareErrorAction, resetDeleteFirmware } from './deleteFirmwareSlice'

export const getFirmwareListingDetails = (page: number, size: number, sortdir: string, sortfield: string, search: string, tenantId: string) => async (dispatch: any) => {
  dispatch(FirmwareListLoadingAction())
  try {
    await FirmwareDetailsService.getFirmwareListingDetails(page, size, sortdir, sortfield, search, tenantId, (firmwareListData, httpStatus) => {
      dispatch(FirmwareListUpdateAction({ data: firmwareListData.firmware, total_count: firmwareListData.total_count, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(FirmwareListErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(FirmwareListErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getFirmwareListingDetailsFilteredData = (page: number, size: number, sortdir: string, sortfield: string, filterParams: any, tenantId: string) => async (dispatch: any) => {
  dispatch(FirmwareListLoadingAction())
  try {
    await FirmwareDetailsService.getFirmwareListingFilteredData(page, size, sortdir, sortfield, filterParams, tenantId, (firmwareListData, httpStatus) => {
      dispatch(FirmwareListUpdateAction({ data: firmwareListData.firmware, total_count: firmwareListData.total_count, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(FirmwareListErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(FirmwareListErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}
export const addFirmware = (firmwareRequestParams: firmwareReq, name: string, tenantId: string) => async (dispatch: any) => {
  dispatch(addFirmwareInfoDataLoading())
  try {
    await AddFirmwareService.addFirmware(firmwareRequestParams, name, tenantId, (message) => {
      dispatch(addFirmwareInfoData(message))
    },
    (errorMessage) => {
      dispatch(addFirmwareInfoDataError(errorMessage))
    })
  } catch (e: any) {
    dispatch(addFirmwareInfoDataError(e))
  }
}

export const resetFirmwareParams = () => async (dispatch: any) => {
  dispatch(resetAddFirmware())
}

export const resetDeleteParams = () => async (dispatch: any) => {
  dispatch(resetDeleteFirmware())
}

export const getFirmwareTypeData = () => async (dispatch: any) => {
  dispatch(FirmwareTypeDataLoadingAction())
  try {
    await AddFirmwareService.getFirmwareTypeData((message) => {
      dispatch(FirmwareTypeDataUpdateAction(message))
    },
    (errorMessage) => {
      dispatch(FirmwareTypeDataErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(FirmwareTypeDataErrorAction(e))
  }
}

export const getFirmwareListingFilterFirmwareType = (tenantId: string) => async (dispatch: any) => {
  dispatch(firmwareListFilterFirmwareTypeLoadingAction())
  try {
    await FirmwareDetailsService.getFirmwareListingFilterFirmwareType(tenantId, (message) => {
      dispatch(firmwareListFilterFirmwareTypeUpdateAction(message))
    },
    (errorMessage) => {
      dispatch(firmwareListFilterFirmwareTypeErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(firmwareListFilterFirmwareTypeErrorAction(e))
  }
}

export const getFirmwareListingFilterAssetType = (tenantId: string) => async (dispatch: any) => {
  dispatch(firmwareListFilterAssetTypeLoadingAction())
  try {
    await FirmwareDetailsService.getFirmwareListingFilterAssetType(tenantId, (message) => {
      dispatch(firmwareListFilterAssetTypeUpdateAction(message))
    },
    (errorMessage) => {
      dispatch(firmwareListFilterAssetTypeErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(firmwareListFilterAssetTypeErrorAction(e))
  }
}

export const getFirmwareListingFilterVersion = (tenantId: string) => async (dispatch: any) => {
  dispatch(firmwareListFilterVersionLoadingAction())
  try {
    await FirmwareDetailsService.getFirmwareListingFilterVersion(tenantId, (message) => {
      dispatch(firmwareListFilterVersionUpdateAction(message))
    },
    (errorMessage) => {
      dispatch(firmwareListFilterVersionErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(firmwareListFilterVersionErrorAction(e))
  }
}
export const exportFirmwareList = (tenantId: string) => async (dispatch: any) => {
  dispatch(exportFirmwareListLoadingAction())
  try {
    await FirmwareDetailsService.exportFirmwareList(tenantId, (message: any) => {
      dispatch(exportFirmwareListUpdateAction(message))
    },
    (errorMessage: any) => {
      dispatch(exportFirmwareListErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(exportFirmwareListErrorAction(e))
  }
}

export const deleteFirmware = (firmwareId: string, tenantId: string) => async (dispatch: any) => {
  dispatch(deleteFirmwareLoadingAction())
  try {
    await FirmwareDetailsService.deleteFirmwareById(firmwareId, tenantId, (message: any) => {
      dispatch(deleteFirmwareUpdateAction(message))
    },
    (errorMessage: any) => {
      dispatch(deleteFirmwareErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(deleteFirmwareErrorAction(e))
  }
}
